import styled, { css } from 'styled-components';

export const IconInBtn = styled.div<{ $size: string }>`
  line-height: 0;
  ${({ $size }) =>
    $size === 'large'
      ? css`
          svg {
            font-size: ${({ theme }) => theme.fs.lg};
          }
        `
      : $size === 'medium'
      ? css`
          svg {
            font-size: ${({ theme }) => theme.fs.md};
          }
        `
      : css`
          svg {
            font-size: ${({ theme }) => theme.fs.sm};
          }
        `};
`;

export const IconEnd = styled(IconInBtn)`
  margin-inline-start: ${({ theme }) => theme.spacing.x1};
`;

export const IconStart = styled(IconInBtn)`
  margin-inline-end: ${({ theme }) => theme.spacing.x1};
`;

export const BtnWrrapper = styled.div<{ $justify: string; $topSpace: string | boolean }>`
  color: ${({ theme }) => theme.palette.white};
  ${({ $justify }) =>
    $justify === 'center'
      ? css`
          &:not(&:first-child) {
            margin-inline-start: ${({ theme }) => theme.spacing.x4};
          }
        `
      : $justify === 'flex-end'
      ? css`
          &:not(&:first-child) {
            margin-inline-start: ${({ theme }) => theme.spacing.x4};
          }
        `
      : $justify === 'flex-start'
      ? css`
          &:not(&:first-child) {
            margin-inline-end: ${({ theme }) => theme.spacing.x4};
          }
        `
      : ''};
  ${({ $topSpace }) =>
    $topSpace === 'small'
      ? css`
          margin-top: ${({ theme }) => theme.spacing.x5};
        `
      : $topSpace === 'medium'
      ? css`
          margin-top: ${({ theme }) => theme.spacing.x6};
        `
      : $topSpace === 'large'
      ? css`
          margin-top: ${({ theme }) => theme.spacing.x7};
        `
      : ''};
`;

export const Button = styled.div<{
  $width?: number | null;
  $disabled?: boolean;
  $buttonColor?: 'info' | 'outlined' | 'text-button' | 'dark' | 'danger' | 'danger-outlined';
  $iconButton?: boolean;
  $size?: 'small' | 'medium' | 'large';
  $circular?: boolean;
  $isLink?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.secondary};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  height: ${({ theme }) => theme.spacing.x8};
  outline: none;
  border: none;
  user-select: none;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fs.xs};
  transition: 0.2s;

  ${({ $circular }) =>
    $circular
      ? css`
          border-radius: 100px;
        `
      : css`
          border-radius: ${({ theme }) => theme.rounded.x1};
        `};

  ${({ $disabled }) =>
    $disabled
      ? css`
          cursor: no-drop;
        `
      : css`
          cursor: pointer;
        `}

  ${({ $disabled }) =>
    $disabled
      ? css`
          &::after {
            content: '';
            position: absolute;
            background: rgba(255, 255, 255, 0.3);
            inset: 0 0 0 0;
          }
        `
      : ''}
  ${({ $width }) =>
    $width
      ? css`
          width: ${$width}px;
        `
      : css`
          width: max-content;
        `}

  ${({ $isLink }) =>
    $isLink
      ? css`
          a {
            padding: ${({ theme }) => theme.spacing.x2};
            display: flex;
            align-items: center;
            color: ${({ theme }) => theme.palette.white};
            line-height: 0;
          }
        `
      : css`
          padding: ${({ theme }) => theme.spacing.x2};
          color: ${({ theme }) => theme.palette.white};
        `}

  ${({ $size }) =>
    $size === 'small'
      ? css`
          height: ${({ theme }) => theme.spacing.x6};
          padding: ${({ theme }) => theme.spacing.x2};
          font-size: ${({ theme }) => theme.fs.xxs};
        `
      : $size === 'large'
      ? css`
          height: ${({ theme }) => theme.spacing.x11};
          border-radius: ${({ theme }) => theme.rounded.x1};
        `
      : css`
          height: ${({ theme }) => theme.spacing.x8};
        `}

  ${({ $buttonColor }) =>
    $buttonColor === 'info'
      ? ''
      : $buttonColor === 'outlined'
      ? css`
          border-radius: ${({ theme }) => theme.rounded.x1};
        `
      : $buttonColor === 'text-button'
      ? css`
          background: transparent;

          &:hover {
            background: rgba(0, 0, 0, 0.05);
          }
          &,
          a {
            color: ${({ theme }) => theme.palette.secondary};
          }
        `
      : $buttonColor === 'danger'
      ? css`
          background: #f55b5d;
        `
      : $buttonColor === 'danger-outlined'
      ? css`
          background: ${({ theme }) => theme.palette.white};
          border: 1px solid ${({ theme }) => theme.palette.error};
          a {
            color: ${({ theme }) => theme.palette.error};
          }
        `
      : ''}
`;
